import ImageComponent from './Image';
import TextComponent from './Text';
import ScrollerComponent from './Scroller';
import ContentComponent from './Content';
import ViewComponent from './ViewTag';

customElements.define('machpro-image', ImageComponent);
customElements.define('machpro-text', TextComponent);
customElements.define('machpro-view', ViewComponent);
customElements.define('machpro-scroller', ScrollerComponent);
customElements.define('machpro-content', ContentComponent);